import React from 'react';
import { ReactEditor } from 'slate-react';
import useLastFocusedEditorSelection from 'components/text-editor/hooks/use-last-focused-editor-selection';
import useOnTextEditorScroll from 'components/text-editor/components/controls/hooks/use-on-text-editor-scroll';
import useEventListener from 'hooks/use-event-listener';
import useCustomEditor from 'components/text-editor/hooks/use-custom-editor';
import { notEqual } from 'utils/js';
import { Node } from 'slate';

export default function useNameEditorPositionStyles() {
  const editor = useCustomEditor();
  const editorSelection = useLastFocusedEditorSelection(editor);

  const [styles, setStyles] = React.useState({});

  useEventListener('resize', updateStyles);

  useOnTextEditorScroll(updateStyles);

  // On selection change
  React.useEffect(() => updateStyles(), [editor.selection]);

  function updateStyles() {
    const selectedNode =
      editorSelection && editor.getSelectedNode(editorSelection);

    if (selectedNode) {
      const newStyles = getSlateNodePositionStyles(editor, selectedNode);

      if (newStyles && notEqual(newStyles, styles)) {
        setStyles(newStyles);
      }
    }
  }

  return styles;
}

function getSlateNodePositionStyles(
  editor: ReactEditor,
  node: Node,
): React.CSSProperties | undefined {
  try {
    const rect = ReactEditor.toDOMNode(editor, node).getBoundingClientRect();

    return rect ? rectToStyles(rect) : undefined;
  } catch {
    return undefined;
  }
}

function rectToStyles({
  top,
  left,
  width,
  height,
}: DOMRect): React.CSSProperties {
  return { top, left, width, height };
}
